import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import { closeDisplays } from "../../state/uiControl/uiControl.actions";

export interface NavigationProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onClickPrevious: () => void;
  onClickNext: () => void;
}

const useStyles = makeStyles((theme) => ({
  closeNav: {
    cursor: "pointer",
    flexGrow: 1,
    textAlign: "center",
  },
  navigation: {
    fontFamily: "OpenSans-Bold",
    color: "#9D7E47",
    fontSize: "14px",
    paddingTop: "0.5rem",
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    gridArea: "navigation",
  },
  nextContainer: {
    textAlign: "end"
  },
  pointer: {
    cursor: "pointer",
  },
}));

export const Navigation: React.FC<NavigationProps> = ({
  hasPrevious,
  hasNext,
  onClickPrevious,
  onClickNext,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  return (
    <div className={classes.navigation}>
      <div>
        {hasPrevious && (
          <span className={classes.pointer} onClick={onClickPrevious}>
          Previous
          </span>
        )}
      </div>
      <div
        className={classes.closeNav}
        onClick={() => dispatch(closeDisplays())}
      >
        Close
      </div>
      <div className={classes.nextContainer}>
        {hasNext && (
          <span className={classes.pointer} onClick={onClickNext}>
          Next
          </span>
        )}
      </div>
    </div>
  );
};

export default Navigation;
